import { Typography } from "@/components/kit";

interface IStepCardProps {
  title: string;
  description: string;
  children: React.ReactNode;
  className?: string;
}

function StepCard({
  title,
  description,
  children,
  className = "",
}: IStepCardProps) {
  return (
    <section
      className={`flex flex-col gap-y-5 border border-gray-100 h-full rounded-2xl ${className}`}
    >
      <div className="flex flex-col gap-y-1 pt-5 px-6">
        <Typography variant="Title5-Regular">{title}</Typography>
        <Typography variant="Body3-Regular" color="text-gray-300">
          {description}
        </Typography>
      </div>
      <div className="overflow-auto h-full">{children}</div>
    </section>
  );
}

export default StepCard;
